export { withCollectionFallback } from './withCollectionFallback';
